import React, { useState } from "react";
import { CaretDown } from "@phosphor-icons/react";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";

// Multi-select with an "All" option. value = [] means All.
export default function AreaMultiPick({ label, options, value, onChange, testid }) {
  const [q, setQ] = useState("");
  const shown = options.filter(o => (o.name || "").toLowerCase().includes(q.toLowerCase())).slice(0, 200);
  const names = options.filter(o => value.includes(o.id)).map(o => o.name);
  const toggle = (id) => onChange(value.includes(id) ? value.filter(v => v !== id) : [...value, id]);
  return (
    <div>
      <div className="text-[10px] uppercase tracking-[0.2em] text-[#5C5A55] mb-1.5">{label}</div>
      <Popover>
        <PopoverTrigger asChild>
          <button type="button" data-testid={testid}
            className="w-full h-10 px-3 border border-[#E5E2D9] rounded-md bg-white text-sm flex items-center justify-between text-left">
            <span className="truncate">{value.length ? (names.length > 2 ? `${names.slice(0, 2).join(", ")} +${names.length - 2}` : names.join(", ") || `${value.length} selected`) : "All"}</span>
            <CaretDown size={14} className="shrink-0 text-[#8A8780]" />
          </button>
        </PopoverTrigger>
        <PopoverContent className="w-72 p-2" align="start">
          <input value={q} onChange={e => setQ(e.target.value)} placeholder={`Search ${label.toLowerCase()}…`} data-testid={`${testid}-search`}
            className="w-full h-8 px-2 mb-2 border border-[#E5E2D9] rounded text-xs" />
          <label className="flex items-center gap-2 px-2 py-1.5 text-sm font-semibold border-b border-[#F0EEE7] cursor-pointer">
            <input type="checkbox" checked={!value.length} onChange={() => onChange([])} data-testid={`${testid}-all`} /> All
          </label>
          <div className="max-h-60 overflow-y-auto">
            {shown.map(o => (
              <label key={o.id} className="flex items-center gap-2 px-2 py-1.5 text-sm hover:bg-[#FAFAF7] cursor-pointer">
                <input type="checkbox" checked={value.includes(o.id)} onChange={() => toggle(o.id)} data-testid={`${testid}-opt-${o.id}`} />
                <span className="truncate">{o.name}</span>
              </label>))}
            {!shown.length && <div className="text-xs italic text-[#8A8780] p-2">No matches</div>}
            {options.length > shown.length && shown.length === 200 && <div className="text-[10px] text-[#8A8780] p-2">Showing 200 — type to search more</div>}
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
}
